import { render, staticRenderFns } from "./companyCertification.vue?vue&type=template&id=0769e750&scoped=true"
import script from "./companyCertification.vue?vue&type=script&lang=js"
export * from "./companyCertification.vue?vue&type=script&lang=js"
import style0 from "./companyCertification.vue?vue&type=style&index=0&id=0769e750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0769e750",
  null
  
)

export default component.exports